// extracted by mini-css-extract-plugin
export default {"cls1":"VeloPhoneNumberField-ListIcon_cls1__kMONy","cls2":"VeloPhoneNumberField-ListIcon_cls2__9N7FK VeloPhoneNumberField-ListIcon_cls1__kMONy"};